module.exports = __webpack_public_path__ + "static/img/lightbulb_1.10a29d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lightbulb_1.png
// module id = YisQ
// module chunks = 1